import queryString from 'query-string';
import { inIframe } from '../../tools/dom';
import { isInsideLarkBrowser, isVa } from '../../platform/environment';
import { getAdaptConfigInFeishu } from '../../platform/adaptInFeishu';
import {
  Language,
  LanguageEnumToCode,
  RealLanguage,
  RealLanguageCodeToEnum,
} from '../base/language';
import { getIsOnboardingTaskRelated } from '../../router/onboarding';

// 当前的语言(举例: zh, en, ja)
export let CurLanguage = getCurrentLang();
// 当前的语言(举例：zh-CN, en-US, ja-JP)
export let Locale = LanguageEnumToCode[CurLanguage];
// 是否是中文环境
export let isZh = CurLanguage === Language.ZH;
// 是否是英文环境
export let isEn = CurLanguage === Language.EN;
// 是否是日语环境
export let isJa = CurLanguage === Language.JA;

/**
 * @deprecated 即将弃用, 为了兼容旧版子仓库而暂时保留
 */
export const LOCALE = CurLanguage === Language.ZH ? '' : CurLanguage;
/**
 * @deprecated 即将弃用, 为了兼容旧版子仓库而暂时保留
 */
export const locale = Locale;
/**
 * @deprecated 即将弃用, 为了兼容旧版子仓库而暂时保留
 */
export const isZhLang = isZh;
/**
 * @deprecated 即将弃用, 为了兼容旧版子仓库而暂时保留
 */
export const isEN_US = isEn;
/**
 * 获取当前的语言环境
 */
export function getCurrentLang(lang?: string): RealLanguage {
  const queryParams = queryString.parse(location.search);
  if (getIsOnboardingTaskRelated()) {
    if (queryParams?.lang) {
      return RealLanguageCodeToEnum[(queryParams.lang as string) || ''];
    }
  }
  if (lang) {
    return RealLanguageCodeToEnum[lang];
  }

  // query params 中有 setlang 参数时，本次访问优先以 setlang 为准
  const setlang = queryParams?.setlang;
  if (setlang) {
    const curLang = RealLanguageCodeToEnum[(setlang as string) || ''];
    localStorage.setItem('lang', curLang);
    return curLang;
  }

  // iframe容器内尝试使用query
  if (inIframe()) {
    if (queryParams?.lang) {
      return RealLanguageCodeToEnum[(queryParams.lang as string) || ''];
    }
  }

  // 系统语言，海外锁定EN，非海外取容器语言
  const navigatorLang = RealLanguageCodeToEnum[navigator.language || ''];
  const systemLang = isVa ? Language.EN : navigatorLang;

  /**
   * 飞书集成逻辑
   * 1. isLarkLockSystem=强制跟随容器
   * 2. isLarkSkipLockEnInVa=海外不锁定EN
   * 海外&海外锁定EN时，返回EN
   * 其他情况返回容器语言
   */
  const isInLark = isInsideLarkBrowser();
  const isLarkLockSystem = getAdaptConfigInFeishu('common.lang')?.lockSystem;
  const isLarkSkipLockEnInVa = getAdaptConfigInFeishu('common.lang')?.skipLockEN;
  if (isInLark && isLarkLockSystem) {
    if (isVa && !isLarkSkipLockEnInVa) {
      return Language.EN;
    }
    return navigatorLang;
  }

  // 远端语言逻辑：有远端数据&本地偏好设置已上传时，返回远端语言
  // const isPreferenceUploaded = localStorage.getItem('localstorage_user_preference_uploaded');
  const localLang = localStorage.getItem('lang') as string;
  // if (preference.language && (isPreferenceUploaded || !localLang)) {
  //   return RealLanguageCodeToEnum[preference.language];
  // }

  // localStorage语言
  if (localLang) {
    return RealLanguageCodeToEnum[localLang || ''];
  }

  // 系统语言兜底
  return systemLang;
}

export const updateCurLanguage = (v: RealLanguage = Language.ZH) => {
  CurLanguage = v;
  Locale = LanguageEnumToCode[CurLanguage];
  // 是否是中文环境
  isZh = CurLanguage === Language.ZH;
  // 是否是英文环境
  isEn = CurLanguage === Language.EN;
  // 是否是日语环境
  isJa = CurLanguage === Language.JA;
};
